import _each from "lodash/each";

export default class ConstantModule {
  constructor() {
    this.setupModule();
  }

  setupModule() {
    this.module = {
      state: {
        spWidth: 768,
        tabletWidth: 1024,
        brand: {
          NEWS_LOAD_COUNT: 3
        }
      },

      getters: {},

      // Mutations ----------------------------------------
      mutations: {},
      // Actions ----------------------------------------
      actions: {}
    };
  }

  getModule() {
    return this.module;
  }
}
